export default __webpack_public_path__ + "static/media/corro-enrotllador-JMB-2024.75e2ebcb.png";